import { render } from "./PrivacyPolicyComponent.vue?vue&type=template&id=2935c58e&scoped=true"
import script from "./PrivacyPolicyComponent.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyComponent.vue?vue&type=script&lang=js"

import "./PrivacyPolicyComponent.vue?vue&type=style&index=0&id=2935c58e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2935c58e"]])

export default __exports__